var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTi2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_71_1",
    "data-name": "Component 71 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#fab976"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-library-books",
    "data-name": "Icon material-library-books",
    d: "M5.746,8.491H3V27.71a2.754,2.754,0,0,0,2.746,2.746H24.964V27.71H5.746ZM27.71,3H11.237A2.754,2.754,0,0,0,8.491,5.746V22.219a2.754,2.754,0,0,0,2.746,2.746H27.71a2.754,2.754,0,0,0,2.746-2.746V5.746A2.754,2.754,0,0,0,27.71,3ZM26.337,15.355H12.609V12.609H26.337Zm-5.491,5.491H12.609V18.1h8.237ZM26.337,9.864H12.609V7.118H26.337Z",
    transform: "translate(12.272 12.272)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi2);
export default __webpack_public_path__ + "static/media/ti2.122fa318fbf326d997726931d7486012.svg";
export { ForwardRef as ReactComponent };